<template>
  <div class="desc-txt">
    <p><slot name="btn"></slot></p>
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.desc-txt {
  font-size: 12px;
}
</style>
